<template>
    <div class="search-form2">
        <input type="text" class="search-input" autocomplete="off" id="" name="" title="검색어 입력" placeholder="검색어를 입력하세요" v-model="searchVal" @keyup.enter="searchIncrudeList()">
        <button type="submit" title="검색" class="search-btn" @click.prevent="searchIncrudeList()"><i class="search-icon"></i> <span>검색</span></button>
    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import { $_WC } from '@/confs/common.const.js';

export default {
    data() {
        return {
            searchVal: '',
        }
    },
    watch: {
    },
    components: {
    },
    computed: {
        ...mapGetters({
        }),
    },
    created() {
    },
    methods: {
        searchIncrudeList() {
            if(!!this.searchVal) {
                this.$eventBus.$emit('Set::Search::Value', this.searchVal);
            } else {
                this.$eventBus.$emit('Set::Search::Value', '');
            }
        },
    },
    mixins: [],
};
</script>
